/**
 * Numeric Statistics Card.
 * Displays statistics for numeric columns.
 */

import React from 'react';
import type { NumericStats } from '@excel-ai-studio/shared';
import { ResultCard } from '../common/ResultCard';

interface NumericStatsCardProps {
  readonly stats: readonly NumericStats[];
}

export const NumericStatsCard: React.FC<NumericStatsCardProps> = ({ stats }) => {
  if (stats.length === 0) return null;

  return (
    <ResultCard
      title="Statistiques numériques"
      variant="analysis"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {stats.map((stat) => (
          <div key={stat.column} style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '12px' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>{stat.column}</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '13px' }}>
              <div>
                <span style={{ color: '#666' }}>Min:</span> {stat.min.toFixed(2)}
              </div>
              <div>
                <span style={{ color: '#666' }}>Max:</span> {stat.max.toFixed(2)}
              </div>
              <div>
                <span style={{ color: '#666' }}>Moyenne:</span> {stat.mean.toFixed(2)}
              </div>
              <div>
                <span style={{ color: '#666' }}>Médiane:</span> {stat.median.toFixed(2)}
              </div>
              <div>
                <span style={{ color: '#666' }}>Écart-type:</span> {stat.stddev.toFixed(2)}
              </div>
              <div>
                <span style={{ color: '#666' }}>Valeurs:</span> {stat.count} ({stat.nullCount} nulles)
              </div>
            </div>
          </div>
        ))}
      </div>
    </ResultCard>
  );
};
